import React from 'react';

import LocationsFinder from './locations-finder';

const { UI, Locations, MapsService, Order } = Mobi2Go;

const isForciblyEnabled = () =>
    UI.locations_finder_enabled ||
    Mobi2Go.helpers.getQueryStringAsObject().enable_locations_finder;

const isForciblyDisabled = () =>
    UI.locations_finder_disabled ||
    Mobi2Go.helpers.getQueryStringAsObject().disable_locations_finder;

Order.onReady(() => {
    let is_enabled = false;

    // Do not enable for locations that do suburb lists as
    // suburbs may not match with Google address results
    const delivery_available_count = Locations.getDeliveryAvailableCount();
    if (delivery_available_count === 0) {
        is_enabled = true;
    } else {
        const locations_with_suburb_list_delivery = Locations.search({
            method: 'delivery',
            status: 'active',
            delivery_mode: 'suburb_list',
        });

        // If no store uses suburb_list delivery, show the new UI
        if (locations_with_suburb_list_delivery.length === 0) {
            is_enabled = true;
        }
    }

    // Only request coordinates if enabled
    if (is_enabled && Locations.get().length > 1) {
        MapsService.requestCoordinates();
    }

    const modal = UI.ExternalModal.create(
        'locations-finder',
        <LocationsFinder
            closeModal={retain_overlay => {
                modal.close(retain_overlay);
            }}
        />,
        {
            'data-view': 'locations-finder',
            className: 'm2g-locations-finder-modal',
        }
    );

    modal.mount();

    UI.bind('showLocationsFinder', () => {
        if ((is_enabled || isForciblyEnabled()) && !isForciblyDisabled()) {
            if (Locations.get().length > 1) {
                MapsService.requestCoordinates();
            }
            modal.open();
        } else {
            // Use old 'location browser' if disabled
            UI.trigger('showLocations');
        }
    });

    UI.bind('forceShowLocationsFinder', () => {
        modal.open();
    });
});
